module.exports = __webpack_public_path__ + "20aaefed8efb25f79adcd601a765563a.svg";